export function Slider() {
  const elements = document.querySelectorAll(".slider")

  elements.forEach((element) => {
    const parent = element.parentNode.closest(".field__item")
    const header = parent.querySelector(".section-header")
    const gridItems = element.querySelectorAll(".tile-grid__container--item")
    let offset = 0
    const gridCount = window.matchMedia("(min-width: 768px)").matches ? 3 : 1
    const gridItemWidth = gridItems[0].clientWidth

    function slidePrev() {
      if (offset >= 0) {
        return
      }
      gridItems.forEach((element) => {
        element.style.transform =
          "translateX(" + (offset + gridItemWidth) + "px)"
      })
      offset = offset + gridItemWidth
    }

    function slideNext() {
      if (offset <= -1 * gridItemWidth * (gridItems.length - gridCount)) {
        return
      }
      gridItems.forEach((element) => {
        element.style.transform =
          "translateX(" + (offset - gridItemWidth) + "px)"
      })
      offset = offset - gridItemWidth
    }

    parent.classList.add("has-slider")

    const buttonWrapper = document.createElement("div")
    buttonWrapper.classList.add("slider__buttons")

    const sliderPrev = document.createElement("button")
    sliderPrev.innerHTML = "<span>&#10094;</span>"
    sliderPrev.title = "Previous (arrow left)"
    sliderPrev.classList.add("btn", "btn-slider", "btn-slider-prev")
    sliderPrev.addEventListener("click", slidePrev, false)
    const sliderNext = document.createElement("button")
    sliderNext.innerHTML = "<span>&#10095;</span>"
    sliderNext.title = "Next (arrow right)"
    sliderNext.classList.add("btn", "btn-slider", "btn-slider-next")
    sliderNext.addEventListener("click", slideNext, false)

    function addButtons() {
      if (header) {
        header.appendChild(buttonWrapper)
      } else {
        element.insertBefore(buttonWrapper, element.firstChild)
      }
      buttonWrapper.appendChild(sliderPrev)
      buttonWrapper.appendChild(sliderNext)
    }

    addButtons()
  })
}
